import { ClipLoader } from 'react-spinners';
import { HelElement, HelFC } from '../../interfaces';

export const Spinner:HelFC<{ text?: string, color?: string }> = ({ text, color = '#fff' }): HelElement => (
  <div className="spinner">
    {!!text && <span>{text}</span>}
    <ClipLoader color={color} size={16} loading />
  </div>
);
